// extracted by mini-css-extract-plugin
export default {"counter__wrapper":"counter_counter__wrapper__XFIVA"};